<template>
  <v-dialog v-model="value" @input="v => v || closeAction()" max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ $t("showSparePart") }}</span>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex md6>
            <v-list two-line>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="primary">train</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title
                    >{{ sparePart.vehicle.name }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("vehicle") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ sparePart.type.name }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("type") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ sparePart.serial_number }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("serialNumber") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ $t("sparePartStatus." + sparePart.status) }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("status") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action
                  v-if="sparePart.unable_to_read_serial_number_properly"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon color="red" v-on="on">warning</v-icon>
                    </template>
                    <span>{{ $t("unreadableSerialNumber") }}</span>
                  </v-tooltip>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-flex>

          <v-flex md6>
            <v-list two-line>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ sparePart.installed_at | moment("LLL") }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("installedAt") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ sparePart.installed_by.name }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("installedBy") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile v-if="sparePart.status === 'REPLACED'">
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ sparePart.replaced_at | moment("LLL") }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("replacedAt") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile v-if="sparePart.status === 'REPLACED'">
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ sparePart.replaced_by.name }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("replacedBy") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["value"],
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["sparePart"])
  },
  methods: {
    closeAction() {
      this.$emit("input", false);
    }
  }
};
</script>

<style scoped></style>
